import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';

import FormCheckbox from 'webapp/components/form/checkbox';

interface MetricEditHistoricalDataPersistenceComponentInterface {
	Args: {
		selected: boolean | null; // null: not set on the metric yet
		submitInProgress: boolean;
		onChange: (value: boolean) => void;
		theme?: string;
	};
}

const MetricEditHistoricalDataPersistenceComponent: TOC<MetricEditHistoricalDataPersistenceComponentInterface> =
	<template>
		<div class="row historical-data-persistence">
			<FormCheckbox
				@name="historical_data_persistence"
				@isDisabled={{@submitInProgress}}
				@selected={{@selected}}
				@label="Append data to preserve history"
				@onChange={{@onChange}}
				@item={{hash
					tooltip="Enable to add new data to the existing dataset without replacing it."
					tooltipMaxWidth=230
				}}
				@theme={{@theme}}
			/>
		</div>
	</template>;

export default MetricEditHistoricalDataPersistenceComponent;
